import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  StyledLabel,
  StyledBoxModuleRow,
  StyledRadioButton,
  StyledOrderItem,
  StyledIcon,
  StyledBoxRaLabel
} from './style';
import {
  StyleWrapIcon,
  StyledWrapInputs,
  StyledBoxTwoComponents,
  StyledBoxInputRowTwoBis
} from './styleAwards';

import DropdownInput from '../../../core/DropdownInput';

import Input from '../../../core/Input';
import { LANGUAGE } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images/index';

import { getLanguages } from '../../../../utils/apiDataUserForm';

const LanguageItem = ({
  certification,
  listNivel,
  name,
  onChangeInputName,
  onChangeInputProficiency,
  onChangeIdLanguage,
  onChangeRadioLevel,
  onChangeRadioCertification,
  onClickDelete,
  onClickDown,
  onClickUp,
  order,
  proficiency,
  accreditation,
  formUser
}) => {
  const [languages, setLanguages] = useState([{ value: 0, text: '' }]);
  // eslint-disable-next-line no-unused-vars
  const [language, setLanguage] = useState(null);
  useEffect(() => {
    if (formUser) {
      getLanguages().then(lg => setLanguages(lg));
    }
  }, []);
  return (
    <StyledBoxModuleRow>
      <StyledOrderItem
        order={order}
        onClickDown={onClickDown}
        onClickUp={onClickUp}
      />
      <StyledWrapInputs>
        <StyledBoxInputRowTwoBis>
          <StyledBoxTwoComponents>
            <StyledLabel>{LANGUAGE.NAME}</StyledLabel>
            {!formUser ? (
              <Input onChange={onChangeInputName} value={name} />
            ) : (
              <DropdownInput
                className="form-dropdown"
                list={languages}
                label={`${name || 'Seleccionar Idioma'} `}
                onSelect={e => {
                  onChangeIdLanguage(e.languageId);
                  onChangeInputName(e.name);
                  setLanguage(e.id);
                }}
              />
            )}
          </StyledBoxTwoComponents>
          <StyledBoxTwoComponents>
            <StyledLabel>{LANGUAGE.PROFICIENCY}</StyledLabel>
            {listNivel.map(item => (
              <StyledRadioButton
                key={`${item.value}`}
                id={`${item.value}-${order}`}
                checked={proficiency === item.value}
                label={item.text}
                value={item.value}
                onChange={onChangeRadioLevel}
              />
            ))}
          </StyledBoxTwoComponents>
        </StyledBoxInputRowTwoBis>
        <StyledBoxInputRowTwoBis>
          <StyledBoxTwoComponents>
            <StyledLabel>{LANGUAGE.DEGREE}</StyledLabel>
            <Input onChange={onChangeInputProficiency} value={certification} />
          </StyledBoxTwoComponents>
          <StyledBoxTwoComponents>
            <StyledLabel>{LANGUAGE.CERTIFICATION}</StyledLabel>
            <StyledBoxRaLabel>
              <StyledRadioButton
                key="Accreditation_Yes"
                id={`Accreditation_Yes-${order}`}
                checked={accreditation === 'true'}
                label="Si"
                value="true"
                onChange={onChangeRadioCertification}
              />
              <StyledRadioButton
                key="Accreditation_No"
                id={`Accreditation_No-${order}`}
                checked={accreditation !== 'true'}
                label="No"
                value="false"
                onChange={onChangeRadioCertification}
              />
            </StyledBoxRaLabel>
          </StyledBoxTwoComponents>
        </StyledBoxInputRowTwoBis>
      </StyledWrapInputs>
      <StyleWrapIcon>
        <StyledIcon
          className="icon-trash"
          svg={Trash}
          size="m"
          hover
          onClick={onClickDelete}
        />
      </StyleWrapIcon>
    </StyledBoxModuleRow>
  );
};

LanguageItem.propTypes = {
  certification: PropTypes.string,
  listNivel: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      text: PropTypes.string
    })
  ),
  formUser: PropTypes.bool,
  name: PropTypes.string,
  onChangeInputName: PropTypes.func,
  onChangeInputProficiency: PropTypes.func,
  onChangeRadioLevel: PropTypes.func,
  onChangeRadioCertification: PropTypes.func,
  onClickDelete: PropTypes.func,
  onChangeIdLanguage: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  order: PropTypes.number,
  proficiency: PropTypes.string,
  accreditation: PropTypes.string
};

LanguageItem.defaultProps = {
  certification: '',
  name: '',
  accreditation: false,
  formUser: false
};

export default LanguageItem;
